import { Trans, useTranslation } from "react-i18next";
import * as R from "remeda";

import { tc } from "@/components/i18n";
import { HelpWrapper } from "@/components/help/HelpWrapper";

interface MSM1a2GenericHelpProps {
  showToggle: boolean;
}

export function MSM1a2GenericHelp({ showToggle }: MSM1a2GenericHelpProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "study.msm-1a-2.help.generic" });
  const steps = t("steps", { returnObjects: true });

  return (
    <HelpWrapper
      showToggle={showToggle}
      buttonText={<Trans t={t} i18nKey="button" components={tc} />}
      headerText={<Trans t={t} i18nKey="header" components={tc} />}
      steps={R.pipe(
        steps,
        R.keys(),
        R.map((k) => <Trans t={t} i18nKey={`steps.${k}`} components={tc} />),
      )}
      footerText={<Trans t={t} i18nKey="footer" components={tc} />}
    />
  );
}

export function MSM1a2ExportHelp({ showToggle }: MSM1a2GenericHelpProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "study.msm-1a-2.help.export" });
  const steps = t("steps", { returnObjects: true });

  return (
    <HelpWrapper
      showToggle={showToggle}
      buttonText={<Trans t={t} i18nKey="button" components={tc} />}
      headerText={<Trans t={t} i18nKey="header" components={tc} />}
      steps={R.pipe(
        steps,
        R.keys(),
        R.map((k) => <Trans t={t} i18nKey={`steps.${k}`} components={tc} />),
      )}
      footerText={<Trans t={t} i18nKey="footer" components={tc} />}
    />
  );
}

interface MSM1a2FileUploadHelpProps {
  showToggle: boolean;
  invalidFlow: boolean;
}

export function MSM1a2FileUploadHelp({ showToggle, invalidFlow }: MSM1a2FileUploadHelpProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "study.msm-1a-2.help.fileUpload" });
  const steps = t("steps", { returnObjects: true });

  return (
    <HelpWrapper
      showToggle={showToggle}
      buttonText={
        <Trans t={t} i18nKey={invalidFlow ? "invalidFlowButton" : "button"} components={tc} />
      }
      headerText={
        <Trans t={t} i18nKey={invalidFlow ? "invalidFlowHeader" : "header"} components={tc} />
      }
      steps={R.pipe(
        steps,
        R.keys(),
        R.map((k) => <Trans t={t} i18nKey={`steps.${k}`} components={tc} />),
      )}
      footerText={<Trans t={t} i18nKey="footer" components={tc} />}
    />
  );
}

interface MSM1a3GenericHelpProps {
  showToggle: boolean;
}

export function MSM1a3GenericHelp({ showToggle }: MSM1a3GenericHelpProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "study.msm-1a-3.help.generic" });
  const steps = t("steps", { returnObjects: true });

  return (
    <HelpWrapper
      showToggle={showToggle}
      buttonText={<Trans t={t} i18nKey="button" components={tc} />}
      headerText={<Trans t={t} i18nKey="header" components={tc} />}
      steps={R.pipe(
        steps,
        R.keys(),
        R.map((k) => <Trans t={t} i18nKey={`steps.${k}`} components={tc} />),
      )}
      footerText={<Trans t={t} i18nKey="footer" components={tc} />}
    />
  );
}

export function MSM1a3ExportHelp({ showToggle }: MSM1a3GenericHelpProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "study.msm-1a-3.help.export" });
  const steps = t("steps", { returnObjects: true });

  return (
    <HelpWrapper
      showToggle={showToggle}
      buttonText={<Trans t={t} i18nKey="button" components={tc} />}
      headerText={<Trans t={t} i18nKey="header" components={tc} />}
      steps={R.pipe(
        steps,
        R.keys(),
        R.map((k) => <Trans t={t} i18nKey={`steps.${k}`} components={tc} />),
      )}
      footerText={<Trans t={t} i18nKey="footer" components={tc} />}
    />
  );
}

interface MSM1a3FileUploadHelpProps {
  showToggle: boolean;
  invalidFlow: boolean;
}

export function MSM1a3FileUploadHelp({ showToggle, invalidFlow }: MSM1a3FileUploadHelpProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "study.msm-1a-3.help.fileUpload" });
  const steps = t("steps", { returnObjects: true });

  return (
    <HelpWrapper
      showToggle={showToggle}
      buttonText={
        <Trans t={t} i18nKey={invalidFlow ? "invalidFlowButton" : "button"} components={tc} />
      }
      headerText={
        <Trans t={t} i18nKey={invalidFlow ? "invalidFlowHeader" : "header"} components={tc} />
      }
      steps={R.pipe(
        steps,
        R.keys(),
        R.map((k) => <Trans t={t} i18nKey={`steps.${k}`} components={tc} />),
      )}
      footerText={<Trans t={t} i18nKey="footer" components={tc} />}
    />
  );
}
